import React from 'react';
import * as yup from 'yup';
import { Modal } from '@web/components';
import { CMSBlok } from '../CMSBlok';

export const component = Modal;

export const schema = yup
  .object({
    children: yup.array(yup.object()),
  })
  .transform(value => ({
    children: value?.children.map(innerContent => (
      <CMSBlok key={innerContent._uid} content={innerContent} />
    )),
  }));
